import { LinearProgress, Tooltip } from '@material-ui/core';
import { ColorDynamic, Inline } from '@superdispatch/ui';
import { Box, TextBox } from '@superdispatch/ui-lab';
import styled from 'styled-components';
import { useUnlockUtils } from '../unlock/UnlockUtils';
import { DescriptionTooltipContent } from './DescriptionTooltipContent';

const StyledLinearProgress = styled(LinearProgress)<{ isOverLimit: boolean }>`
  height: 8px;
  border-radius: 6px;
  background-color: ${ColorDynamic.Silver400};

  & .MuiLinearProgress-bar {
    background-color: ${({ isOverLimit }) =>
      isOverLimit ? ColorDynamic.Yellow300 : ColorDynamic.Green300};
  }
`;

const TooltipTitle = styled(TextBox)`
  cursor: pointer;
  text-decoration: dashed underline ${ColorDynamic.Silver500};
  text-underline-offset: 4px;
  &:hover {
    color: ${ColorDynamic.Blue500};
    text-decoration: dashed underline ${ColorDynamic.Blue500};
  }
`;

function formatUsage(usage: number | null) {
  if (!usage) {
    return '0';
  }

  return usage < 1000 ? `${usage}` : `${usage / 1000}k`;
}

export function UsageProgress() {
  const { isLimited, usedCount, limit, isLimitReached } = useUnlockUtils();

  if (!isLimited) {
    return null;
  }

  const usagePercentage = (usedCount / limit) * 100;

  return (
    <Inline
      space="small"
      verticalAlign="center"
      horizontalAlign={['center', 'left']}
    >
      <Inline space="xsmall" verticalAlign="center">
        <Tooltip
          arrow={true}
          placement="top"
          interactive={true}
          title={<DescriptionTooltipContent />}
        >
          <TooltipTitle variant="hint">Free Insights Used</TooltipTitle>
        </Tooltip>

        <Box width="116px">
          <StyledLinearProgress
            variant="determinate"
            value={usagePercentage < 100 ? usagePercentage : 100}
            valueBuffer={100}
            isOverLimit={isLimitReached}
          />
        </Box>
        <TextBox variant="hint">
          {formatUsage(usedCount)} / {formatUsage(limit)}
        </TextBox>
      </Inline>

      {isLimitReached && (
        <TextBox variant="hint">
          You&apos;ve reached your free usage limit.
        </TextBox>
      )}
    </Inline>
  );
}
